module.exports = __webpack_public_path__ + "img/franklin.d612db19.jpg";